import { render, staticRenderFns } from "./UploadHeader.vue?vue&type=template&id=7746c88b&scoped=true"
import script from "./UploadHeader.vue?vue&type=script&lang=ts"
export * from "./UploadHeader.vue?vue&type=script&lang=ts"
import style0 from "./UploadHeader.vue?vue&type=style&index=0&id=7746c88b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7746c88b",
  null
  
)

export default component.exports